// import Vue from 'vue'
// import VueRouter from 'vue-router'
import Home from '@/pages/home/Home'
import Term from '@/pages/common/Term'
import Privacy from '@/pages/common/Privacy'
import Protocol from '@/pages/common/Protocol'
import Error404 from '@/pages/common/Error404'
import Gateway from '@/pages/common/Gateway'
import RemittanceAccount from '@/pages/common/RemittanceAccount'
import Login from '@/pages/login/Login'
import UserCenterReturn from '@/pages/login/UserCenterReturn'
import Product from '@/pages/product/Product'
import OrderConfirm from '@/pages/order/OrderConfirm'
import OrderPay from '@/pages/order/OrderPay'
import PayQRCode from '@/pages/pay/PayQRCode'
import PayTrans from '@/pages/pay/PayTrans'
import PayReturn from '@/pages/pay/PayReturn'
import Personal from '@/pages/personal/Personal'
import OrderList from '@/pages/personal/OrderList'
import OrderDetail from '@/pages/order/OrderDetail'
import InvoiceDetail from '@/pages/invoice/InvoiceDetail'
import PowerList from '@/pages/personal/PowerList'
import ExtraProduct from '@/pages/personal/ExtraProduct'
import CardPay from '@/pages/personal/CardPay'
import CardList from '@/pages/personal/CardList'
import ClientProduct from '@/pages/client/Product'
import ClientOrder from '@/pages/client/Order'
import ClientPayFinsh from '@/pages/client/PayFinsh'
import ClientRenewTip from '@/pages/client/RenewTip'
// 活动页面
import GiftPages from '@/pages/activity/GiftPages'
import Summer202008 from '@/pages/activity/Summer202008'
import GiftPages08 from '@/pages/activity/GiftPages08'
import OYB116 from '@/pages/activity/OYB116'
import FreeTarget from '@/pages/market/FreeTarget'
import Free333 from '@/pages/activity/Free333'
import Free333Success from '@/pages/activity/Free333Success'
import DoubelEleven1 from '@/pages/activity/DoubelEleven1'
import DoubelEleven2 from '@/pages/activity/DoubelEleven2'
import FourMethods from '@/pages/activity/FourMethods'



Vue.use(VueRouter)

export default new VueRouter({
  fallback: false,
  mode: 'history',
  base: 'shop-xxkj-web',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/term',
      name: 'Term',
      component: Term
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/userCenterReturn',
      name: 'UserCenterReturn',
      component: UserCenterReturn
    },
    {
      path: '/product/:id?',
      name: 'Product',
      component: Product
    },
    {
      path: '/order/confirm/:spuId/:stockUnit',
      name: 'OrderConfirm',
      component: OrderConfirm
    },
    {
      path: '/order/pay/:orderId',
      name: 'OrderPay',
      component: OrderPay
    },
    {
      path: '/order/detail/:id',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/invoice/detail/:orderId',
      name: 'InvoiceDetail',
      component: InvoiceDetail
    },
    {
      path: '/pay/qrcode/:orderId/:payMode',
      name: 'PayQRCode',
      component: PayQRCode
    },
    {
      path: '/pay/trans/:orderId/:busId/:bankId',
      name: 'PayTrans',
      component: PayTrans
    },
    {
      path: '/pay/return',
      name: 'PayReturn',
      component: PayReturn
    },
    {
      path: '/personal',
      name: 'Personal',
      component: Personal,
      redirect:'/personal/orderlist',
      children: [
        {
          path: 'orderlist',
          name: 'OrderList',
          component: OrderList,
        },
        {
          path: 'powerlist',
          name: 'PowerList',
          component: PowerList,
        },
        {
          path: 'extraproduct',
          name: 'ExtraProduct',
          component: ExtraProduct,
        },
        {
          path: 'cardpay',
          name: 'CardPay',
          component: CardPay,
        },
        {
          path: 'cardlist',
          name: 'CardList',
          component: CardList,
        },
      ]
    },
    {
      path: '/client/product.html',
      name: 'ClientProduct',
      component: ClientProduct
    },
    {
      path: '/client/order/:orderId',
      name: 'ClientOrder',
      component: ClientOrder
    },
    {
      path: '/client/payfinsh',
      name: 'ClientPayFinsh',
      component: ClientPayFinsh
    },
    {
      path: '/client/renewtip',
      name: 'ClientRenewTip',
      component: ClientRenewTip
    },
    {
      path: '/remittanceAccount',
      name: 'RemittanceAccount',
      component: RemittanceAccount
    },
    {
      path: '/404',
      name: 'Error404',
      component: Error404
    },
    {
      path: '/gateway',
      name: 'Gateway',
      component: Gateway
    },
    //活动页面
    {
      path: '/giftPages',
      name: 'GiftPages',
      component: GiftPages
    },
    {
      path: '/summer202008',
      name: 'Summer202008',
      component: Summer202008
    },
    {
      path: '/activity/oyb116',
      name: 'OYB116',
      component: OYB116
    },
    {
      path: '/activity/free333',
      name: 'Free333',
      component: Free333
    },
    {
      path: '/activity/free333Success',
      name: 'Free333Success',
      component: Free333Success
    },
    {
      path: '/giftPages08',
      name: 'GiftPages08',
      component: GiftPages08
    },
    {
      path: '/market/freeTarget',
      name: 'FreeTarget',
      component: FreeTarget
    },
    // 双十一
    {
      path: '/doubelEleven1',
      name: 'doubelEleven1',
      component: DoubelEleven1
    },
    {
      path: '/doubelEleven2',
      name: 'doubelEleven2',
      component: DoubelEleven2
    },
    // 体验四维战法
    {
      path: '/activity/fourMethods',
      name: 'fourMethods',
      component: FourMethods
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js